import { API_ENDPOINTS } from "../constants/endpoints";
import api from "../lib/axios";

export interface IChatbotPayload {
  userQuery: string;
  requestId: string;
  sessionId: string;
  topic: string;
}

export const getChatbotResponse = (
  payload: IChatbotPayload,
  options?: { signal?: AbortSignal }
) => {
  const body = {
    userQuery: payload.userQuery,
    requestId: payload.requestId,
    sessionId: payload.sessionId,
    sessionTopic: payload.topic,
  };

  return api.post(
    `${API_ENDPOINTS.CLIMATE_ASSISTANT.ASSISTANT_RESPONSE}`,
    body,
    { signal: options?.signal }
  );
};

export const getPrompts = (query?: string) => {
  let endpoints = API_ENDPOINTS.CLIMATE_ASSISTANT.GET_PROMPTS;

  if (query) {
    endpoints = `${endpoints}?query=${query}`;
  }

  return api.get(endpoints);
};
